import fetchData from 'src/utils/fetchData';

export const postInvitationFromOrganizationAPI = async (data: any) => {
  return fetchData('/ui/front-api/public/invitations/find', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: data,
  });
};
